document.addEventListener("DOMContentLoaded", () => {

    // =========================================
    // HERO SECTION
    // =========================================

    const header = document.querySelector("header");
    const hero = document.querySelector(".hero-banner");
    const heading = document.querySelector(".hero-banner h1");
    const text = document.querySelector(".hero-banner p");
    const button = document.querySelector(".hero-banner .cta-block");

    if (hero && header && heading && text && button) {

        const heroBg = hero.querySelector(".bg");
        const heroImage = hero.querySelector(".hero-banner__image");

        gsap.set(header, { yPercent: -100 });
        gsap.set(heroBg, { yPercent: 100 });

        gsap.set(heroImage, {
            opacity: 0,
            scale: 2,
            yPercent: 200,
        });

        gsap.set(heading, {
            clipPath: "inset(0% 0% 100% 0%)",
            opacity: 0
        });

        gsap.set(text, {
            yPercent: 100,
            opacity: 0
        });

        gsap.set(button, {
            xPercent: 10,
            opacity: 0
        });

        const heroBannerTl = gsap.timeline({
            delay: 0.6
        });

        heroBannerTl
            .to(heroBg, {
                yPercent: 0,
                duration: 1
            })
            .to(heroImage, {
                opacity: 1,
                scale: 1,
                yPercent: 0,
                duration: 1,
            }, "<")
            .to(header, {
                yPercent: 0,
                duration: 1
            })
            .to(heading, {
                clipPath: "inset(0% 0% 0% 0%)",
                opacity: 1,
                duration: 1
            })
            .to(text, {
                yPercent: 0,
                opacity: 1,
                duration: 1
            })
            .to(button, {
                xPercent: 0,
                opacity: 1,
                duration: 1
            }, "<");
    }


    // =========================================
    // BRAND STORY
    // =========================================

    if (document.querySelector(".brand-story")) {

        gsap.set(".brand-story__heading h2", {
            clipPath: "inset(0% 0% 100% 0%)",
            opacity: 0
        });

        gsap.set(".brand-story__text", {
            yPercent: 100,
            opacity: 0
        });

        const brandStoryTl = gsap.timeline({
           scrollTrigger: {
    trigger: ".brand-story",
    start: "top bottom",
    end: () => {
        if (window.innerWidth <= 768) {
            return "+=500vh";
        }

        if (window.innerWidth <= 1366) {
            return "+=700vh";
        }

        return "+=1000vh";
    },
    scrub: 2,
}
        });

        brandStoryTl
            .to(".brand-story__heading h2", {
                clipPath: "inset(0% 0% 0% 0%)",
                opacity: 1,
                duration: 8,
                ease: "none"
            })
            .to(".brand-story__text", {
                yPercent: 0,
                opacity: 1,
                duration: 12,
                ease: "power1.out"
            }, "-=6");
    }


    // =========================================
    // FEATURED PRODUCTS
    // =========================================
    
    const featuredProductsScroll = document.querySelector(".featured-products-scroll");
    const featuredProductsSection = document.querySelector(".featured-products");
    
    const isShopPage = document.querySelector(".featured-products-scroll.is-shop-page");

    if (featuredProductsScroll && featuredProductsSection && !isShopPage && screen.width > 1026) {

        gsap.set(featuredProductsSection.querySelector(".featured-products__heading h2"), {
            clipPath: "inset(0% 100% 0% 0%)",
            opacity: 0
        });

        gsap.set(featuredProductsSection.querySelector(".featured-products__categories"), {
            xPercent: -50,
            opacity: 0
        });

        gsap.set(featuredProductsSection.querySelectorAll(".featured-products__group"), {
            yPercent: 80,
            opacity: 0
        });

        gsap.set(featuredProductsSection.querySelectorAll(".product-card"), {
            yPercent: 100,
            opacity: 0
        });

        const featureProductTl = gsap.timeline({
            scrollTrigger: {
                trigger: featuredProductsScroll,
                start: "top top",
                end: "bottom bottom",
                scrub: 1,
                invalidateOnRefresh: true
            }
        });

        featureProductTl
            .to(featuredProductsSection.querySelector(".featured-products__heading h2"), {
                clipPath: "inset(0% 0% 0% 0%)",
                opacity: 1,
                duration: 2.5
            })
            .to(featuredProductsSection.querySelector(".featured-products__categories"), {
                xPercent: 0,
                opacity: 1,
                duration: 1.5,
                ease: "power1.out"
            }, "+=0.5")
            .to(featuredProductsSection.querySelectorAll(".featured-products__group"), {
                yPercent: 0,
                opacity: 1,
                duration: 5
            })
            .to(featuredProductsSection.querySelectorAll(".product-card"), {
                yPercent: 0,
                opacity: 1,
                duration: 5,
                stagger: 3,
                ease: "power1.out"
            });
    }

    // =========================================
    // TRENDING PRODUCTS
    // =========================================

  const trendingScroll = document.querySelector(".trending-products-scroll");
    const trendingSection = document.querySelector(".trending-products");
    const trendingHeading = document.querySelector(".trending-products__heading");
    const trendingTrack = document.querySelector(".trending-products__products");
    const trendingCards = document.querySelectorAll(".trending-products__product");

    if (trendingScroll && trendingSection && trendingHeading && trendingTrack && screen.width > 1026) {

        const getTrendingScrollAmount = () => {
            const trackWidth = trendingTrack.scrollWidth;
            const visibleWidth = trendingTrack.parentElement.offsetWidth;

            return Math.max(
                0,
                trackWidth - visibleWidth
            );
        };

        // GSAP MatchMedia Setup
        let mm = gsap.matchMedia();

        // 1) DESKTOP SCREENS (1027px and above) - With Horizontal Scroll
        mm.add("(min-width: 1027px)", () => {
            
            gsap.set(trendingHeading, { opacity: 0, clipPath: "inset(0% 0% 100% 0%)" });
            gsap.set(trendingTrack, { y: 200, x: 0, opacity: 0 });
            gsap.set(trendingCards, { yPercent: 100, opacity: 0 });

            const trendingProductsTl = gsap.timeline({
                scrollTrigger: {
                    trigger: trendingScroll,
                    start: "top top",
                    end: "bottom bottom",
                    scrub: 1,
                    invalidateOnRefresh: true
                }
            });

            trendingProductsTl
                .to(trendingHeading, { opacity: 1, clipPath: "inset(0% 0% 0% 0%)", duration: 2, ease: "power2.out" })
                .to(trendingTrack, { y: 0, opacity: 1, duration: 1.5, ease: "power2.out" }, "+=0.5")
                .to(trendingCards, { yPercent: 0, opacity: 1, duration: 2, stagger: 5, ease: "power1.out" })
                // Horizontal scrolling animation
                .to(trendingTrack, { x: () => -getTrendingScrollAmount(), duration: 8, ease: "none" });
        });

        // 2) TABLET & MOBILE SCREENS (1026px and below) - No Horizontal Scroll
        mm.add("(max-width: 1026px)", () => {
            
            gsap.set(trendingHeading, { opacity: 0, clipPath: "inset(0% 0% 100% 0%)" });
            gsap.set(trendingTrack, { y: 150, x: 0, opacity: 0 }); // Thora kam y-axis taake mobile par theek lagay
            gsap.set(trendingCards, { yPercent: 50, opacity: 0 });

            const trendingProductsTl = gsap.timeline({
                scrollTrigger: {
                    trigger: trendingScroll,
                    start: "top top",
                    end: "bottom center", // Scroll end point adjust kiya gaya hai
                    scrub: 1,
                    invalidateOnRefresh: true
                }
            });

            trendingProductsTl
                .to(trendingHeading, { opacity: 1, clipPath: "inset(0% 0% 0% 0%)", duration: 2, ease: "power2.out" })
                .to(trendingTrack, { y: 0, opacity: 1, duration: 1.5, ease: "power2.out" }, "+=0.5")
                .to(trendingCards, { yPercent: 0, opacity: 1, duration: 2, stagger: 2, ease: "power1.out" });
                // Yahan se 'x' wali horizontal line nikal di gayi hai
        });
    }
    else {
     
const slider = document.querySelector('[data-trending-slider]');

if (!slider) return;

// Add Swiper container class
slider.classList.add('swiper');

// Create Swiper wrapper
const wrapper = document.createElement('div');
wrapper.classList.add('swiper-wrapper');

// Get existing product slides
const slides = slider.querySelectorAll('.trending-products__product');

// Move products into the wrapper
slides.forEach((slide) => {
  slide.classList.add('swiper-slide');
  wrapper.appendChild(slide);
});

// Add wrapper inside the slider
slider.appendChild(wrapper);

// Initialize Swiper
new Swiper(slider, {
  slidesPerView: 1,
  spaceBetween: 16,

  breakpoints: {
    576: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 24,
    },
  },

  loop: true,
  navigation: { nextEl: '.trending-slider-arrow--right', prevEl: '.trending-slider-arrow--left', },
});


    }

});